import React, { useState, useEffect } from "react";
import ListaToggleButton from "./fields/ListaToggleButton";
import SwitchConInput from "./fields/SwitchConInput";
import SwitchConNInput from "./fields/SwitchConNInput";

const Serramenti = (props) => {
  const [serramenti, setSerramenti] = useState(
    props.preventivo.serramenti || {
      title: "Serramenti",
      descr:
        "Non e' compresa nel preventivo la fornitura dei serramenti ",

      // demolizione Serramenti
      demolizioneSerramenti: {
        tipologia: "SwitchConNInput",
        titolo: "Demolizione serramenti",
        descrizione: `Valutazione preliminare, Preparazione del sito, smontaggio preliminare, rimozione dei fissaggi, dismantellamento dei telai`,
        valore: false,
        prezzoFinale: 0,
        valoriInput: [
          {
            nome: "Finestre",
            descrizione: "Numero Finestre",
            descQuantita: "n",
            quantita: 0,
            prezzo: 100,
          },
          {
            nome: "Porte Finestra 1 o 2 ante",
            descrizione: "Numero Porte Finestra 1 o 2 ante ",
            descQuantita: "n",
            quantita: 0,
            prezzo: 100,
          },
          {
            nome: "Porta Finestra 2 o più ante",
            descrizione: "Numero Porte Finestra 2 o più ante  ",
            descQuantita: "n",
            quantita: 0,
            prezzo: 100,
          },
          {
            nome: "Cassonetti o Tapparelle",
            descrizione: "Numero cassonetti o tapparelle",
            descQuantita: "n",
            quantita: 0,
            prezzo: 100,
          },
          {
            nome: "Persiane",
            descrizione: " Numero Persiane",
            descQuantita: "n",
            quantita: 0,
            prezzo: 100,
          },
        ],
      },

      // costruzioni controtelai
      costruzioneControtelai: {
        tipologia: "SwitchConInput",
        titolo: "Controtelai Finestra e Porta Finestra",
        descrizione: `Pianificazione e progettazione, preparazione dei materiali, taglio del legname, assemblaggio del talaio, installazione dlele staffe di rinforzo`,
        valore: false,
        descrizioneQuantita: "Numero ",
        descQuantita: "n",
        quantita: 0,
        prezzo: 100,
      },
      // installazioneCassonettiPersiane
      installazioneCassonettiPersiane: {
        tipologia: "SwitchConNInput",
        titolo: "Installazione cassonetti persiane finestre porte finestre  ",
        descrizione: `Valutazione preliminare, Preparazione dell'area, misurazione e posizionamento, montaggio, controllo dell'allineamento e della livellatura, installazione delle guide delle persiane, test di funzionamento `,
        valore: false,
        prezzoFinale: 0,
        valoriInput: [
          {
            nome: "Finestre",
            descrizione: "Numero finestre",
            descQuantita: "n",
            quantita: 0,
            prezzo: 100,
          },          
          {
            nome: "Porte Finestra 1 o 2 ante",
            descrizione: "Numero porte Finestra 1 o 2 ante",
            descQuantita: "n",
            quantita: 0,
            prezzo: 100,
          },
          {
            nome: "Porte Finestra 2 o più ante",
            descrizione: "Numero porte Finestra 2 o più ante",
            descQuantita: "n",
            quantita: 0,
            prezzo: 100,
          },
          {
            nome: "Cassonetti o Tapparelle",
            descrizione: "Numero cassonetti o tapparelle",
            descQuantita: "n",
            quantita: 0,
            prezzo: 100,
          },
          {
            nome: "Persiane",
            descrizione: "Numero persiane ",
            descQuantita: "n",
            quantita: 0,
            prezzo: 100,
          },
        ],
      },
    }
  )

  useEffect(() => {
    /*aggiornare automaticamente i campi dipendenti**/
    
    props.onChange(serramenti);
  }, [serramenti]);

  /* divisore*/
  const divider = (
    <div className="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
  )

  return (
    <>
      <div className="surface-ground px-1 py-1 md:px-4 md:py-4 lg:px-8">
        <div className="text-900 font-medium text-900 text-xl mb-2">
          {serramenti.title}
        </div>
        <p className="m-0 mb-2 p-0 text-600 line-height-3 mr-3">
          {serramenti.descr}
        </p>
        <div className="surface-card p-4 shadow-2 border-round">
          <div className="grid formgrid p-fluid">
            {Object.keys(serramenti).map((key) => (
              <React.Fragment key={key}>
                {serramenti[key].tipologia === "SwitchConInput" && (
                  <>
                    <SwitchConInput
                      field={serramenti[key]}
                      onChange={(data) => {
                        setSerramenti({ ...serramenti, [key]: data });
                      }}
                    />
                    {divider}
                  </>
                )}
                {serramenti[key].tipologia === "SwitchConNInput" && (
                  <>
                    <SwitchConNInput
                      field={serramenti[key]}
                      onChange={(data) => {
                        setSerramenti({ ...serramenti, [key]: data });
                       //  handleCambiaValoriAutomatici(key, data)
                      }}
                    />
                    {divider}
                  </>
                )}
                {serramenti[key].tipologia === "ListaToggleButton" && (
                  <>
                    <ListaToggleButton
                      field={serramenti[key]}
                      onChange={(data) => {
                        setSerramenti({ ...serramenti, [key]: data });
                      }}
                    />
                    {divider}
                  </>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
export default Serramenti;
